import { useSelector } from 'react-redux'

import { isEmpty } from 'lodash-es'

import { getAuthIsLTSupervisor, getAuthLTProviders } from '../data/auth/authSelectors'
import { getLTVideoSessionOpen } from '../lyraTherapy/data/ltVideoSelectors'

/**
 * Whether the provider session area (Join Session banner, video session) stays pinned to the top
 * of the page scroller. For supervisors it scrolls away with the page outside a video session,
 * so anything offsetting itself below the Join Session banner must skip that offset.
 *
 * Must match the `isSticky` condition on `StickyProviderSessionContainer` in App.tsx.
 * TODO: https://lyrahealth.atlassian.net/browse/ICE-7843 when isClientHeaderRedesignEnabled flag
 * is removed
 */
export const useIsProviderSessionSticky = () => {
  const videoSessionOpen = useSelector(getLTVideoSessionOpen)
  const isSupervisor = useSelector(getAuthIsLTSupervisor)
  const BCProviders = useSelector(getAuthLTProviders)
  const shouldSeeSupervisorSearch = isSupervisor && !isEmpty(BCProviders)
  return videoSessionOpen || !shouldSeeSupervisorSearch
}
